// Manufacturing.js

// Inventory Department Risks (20 records)
const manufacturingInventoryRiskData = [
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-001',
    riskDescription: 'Inaccurate stock counts due to manual stocktaking errors - Issue 1',
    riskCause: ['Human error', 'Outdated procedures'],
    consequence: 'Misstated inventory leading to financial misreporting.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-001',
    processControlDescription: 'Perform regular cycle counts and reconcile physical counts with system records.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Count discrepancies', 'Delayed adjustments'],
    auditTestingProcedures: ['Verify physical counts', 'Reconcile with system data']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-002',
    riskDescription: 'Overstated inventory due to duplicate entries - Issue 2',
    riskCause: ['Data entry errors', 'Lack of system validation'],
    consequence: 'Inflated inventory values affecting balance sheet accuracy.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-002',
    processControlDescription: 'Implement data validation checks and de-duplication routines.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Duplicate records', 'Overstated counts'],
    auditTestingProcedures: ['Review system logs', 'Perform duplicate checks']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-003',
    riskDescription: 'Understated inventory due to lost records - Issue 3',
    riskCause: ['Poor record management', 'Lack of backups'],
    consequence: 'Underreported stock causing stockouts and production delays.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-003',
    processControlDescription: 'Maintain digital backups and conduct periodic record audits.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Lost records', 'Data discrepancies'],
    auditTestingProcedures: ['Test backup systems', 'Audit record completeness']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-004',
    riskDescription: 'Inventory shrinkage due to theft and pilferage - Issue 4',
    riskCause: ['Inadequate security', 'Poor surveillance'],
    consequence: 'Loss of inventory and reduced profit margins.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-004',
    processControlDescription: 'Enhance security protocols with surveillance and restricted access.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Monthly',
    processControlOwner: 'Security Manager',
    expectedDeviations: ['Unrecorded thefts', 'Access breaches'],
    auditTestingProcedures: ['Review CCTV footage', 'Conduct random inventory audits']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-005',
    riskDescription: 'Errors in inventory adjustments due to delayed system updates - Issue 5',
    riskCause: ['System lag', 'Manual override errors'],
    consequence: 'Inaccurate inventory levels affecting production planning.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-005',
    processControlDescription: 'Increase update frequency and log all manual overrides.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Delayed updates', 'Unauthorized adjustments'],
    auditTestingProcedures: ['Review update logs', 'Test override controls']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-006',
    riskDescription: 'Excess or insufficient inventory due to poor demand forecasting - Issue 6',
    riskCause: ['Outdated forecasting methods', 'Limited market data'],
    consequence: 'Excess stock or stockouts impacting production and cash flow.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-006',
    processControlDescription: 'Implement advanced forecasting tools and review periodically.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Forecast errors', 'Over/under ordering'],
    auditTestingProcedures: ['Compare forecasts with actuals', 'Review forecasting models']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-007',
    riskDescription: 'Inventory loss due to improper storage and handling - Issue 7',
    riskCause: ['Inadequate storage conditions', 'Poor handling procedures'],
    consequence: 'Damaged goods and increased wastage.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-007',
    processControlDescription: 'Implement proper storage protocols and regular training on handling.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Warehouse Manager',
    expectedDeviations: ['Damaged goods', 'Handling errors'],
    auditTestingProcedures: ['Inspect storage areas', 'Review training records']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-008',
    riskDescription: 'Delayed stock reconciliation causing inventory discrepancies - Issue 8',
    riskCause: ['Inefficient reconciliation process', 'Manual errors'],
    consequence: 'Unreliable inventory data affecting decision-making.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-008',
    processControlDescription: 'Automate reconciliation and perform regular physical counts.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Reconciliation delays', 'Data discrepancies'],
    auditTestingProcedures: ['Review reconciliation reports', 'Conduct surprise counts']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-009',
    riskDescription: 'Inaccurate recording of product returns affecting stock levels - Issue 9',
    riskCause: ['Inefficient returns processing', 'Lack of system integration'],
    consequence: 'Erroneous inventory records and planning issues.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-009',
    processControlDescription: 'Integrate return processing into the inventory system with audits.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Financial',
    frequency: 'Daily',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Misrecorded returns', 'System integration issues'],
    auditTestingProcedures: ['Review return logs', 'Test system integration']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-010',
    riskDescription: 'Data loss from IT failures impacting inventory records - Issue 10',
    riskCause: ['Server outages', 'Inadequate backup procedures'],
    consequence: 'Permanent loss of inventory data and operational disruptions.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-010',
    processControlDescription: 'Establish robust backup and disaster recovery systems.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Data loss incidents', 'Delayed recoveries'],
    auditTestingProcedures: ['Test backup restoration', 'Review disaster recovery drills']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-011',
    riskDescription: 'Mismatch between physical and recorded inventory - Issue 11',
    riskCause: ['Communication gaps', 'Delayed updates'],
    consequence: 'Errors in order fulfillment and production planning.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-011',
    processControlDescription: 'Implement real-time inventory tracking and regular reconciliations.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Inventory mismatches', 'Order errors'],
    auditTestingProcedures: ['Compare physical counts to records', 'Review tracking system logs']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-012',
    riskDescription: 'Damage to goods during handling causing loss - Issue 12',
    riskCause: ['Poor handling procedures', 'Inadequate training'],
    consequence: 'Damaged inventory increasing costs and waste.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-012',
    processControlDescription: 'Enhance handling protocols and provide staff training.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Warehouse Manager',
    expectedDeviations: ['Damaged goods', 'Handling errors'],
    auditTestingProcedures: ['Review training records', 'Inspect damage reports']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-013',
    riskDescription: 'Manual record-keeping errors leading to inventory mismanagement - Issue 13',
    riskCause: ['Reliance on paper records', 'Human error'],
    consequence: 'Inaccurate inventory affecting financial decisions.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-013',
    processControlDescription: 'Transition to an automated inventory management system.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Manual errors', 'Delayed updates'],
    auditTestingProcedures: ['Review system logs', 'Test data accuracy']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-014',
    riskDescription: 'Supplier discrepancies causing inventory misstatements - Issue 14',
    riskCause: ['Inaccurate shipments', 'Poor communication with suppliers'],
    consequence: 'Erroneous inventory levels affecting production planning.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-014',
    processControlDescription: 'Verify supplier shipments with purchase orders and reconcile differences.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Financial',
    frequency: 'Weekly',
    processControlOwner: 'Procurement Manager',
    expectedDeviations: ['Shipment errors', 'Record mismatches'],
    auditTestingProcedures: ['Review supplier records', 'Test reconciliation process']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-015',
    riskDescription: 'Improper handling of returned goods causing inventory distortion - Issue 15',
    riskCause: ['Lack of returns process', 'Poor documentation'],
    consequence: 'Returned items not recorded accurately, skewing inventory data.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-015',
    processControlDescription: 'Establish a standardized process for handling returns with proper documentation.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Weekly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Misrecorded returns', 'Data discrepancies'],
    auditTestingProcedures: ['Review return logs', 'Reconcile with inventory records']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-016',
    riskDescription: 'Inventory mismanagement due to high employee turnover - Issue 16',
    riskCause: ['Frequent staff changes', 'Insufficient training on systems'],
    consequence: 'Loss of expertise and inaccurate inventory management.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-016',
    processControlDescription: 'Improve training programs and implement standardized procedures.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Training gaps', 'Operational errors'],
    auditTestingProcedures: ['Review training records', 'Interview staff']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-017',
    riskDescription: 'Failure to remove obsolete inventory from records - Issue 17',
    riskCause: ['Neglected periodic reviews', 'Inadequate automation'],
    consequence: 'Obsolete stock remaining in active records, skewing data.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-017',
    processControlDescription: 'Conduct regular reviews to remove obsolete items from inventory.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational/Financial',
    frequency: 'Monthly',
    processControlOwner: 'Inventory Manager',
    expectedDeviations: ['Obsolete stock', 'Data inaccuracies'],
    auditTestingProcedures: ['Review obsolete inventory reports', 'Test removal procedures']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-018',
    riskDescription: 'Inefficient use of warehouse space leading to damage - Issue 18',
    riskCause: ['Poor layout design', 'Inadequate handling practices'],
    consequence: 'Damaged goods and reduced storage efficiency.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-018',
    processControlDescription: 'Optimize warehouse layout and train staff on proper handling.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Warehouse Manager',
    expectedDeviations: ['Space mismanagement', 'Increased damage incidents'],
    auditTestingProcedures: ['Review layout plans', 'Inspect damage logs']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-019',
    riskDescription: 'Inefficient tracking of raw material consumption - Issue 19',
    riskCause: ['Manual tracking', 'Lack of automation'],
    consequence: 'Inaccurate consumption data affecting production planning.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-INV-019',
    processControlDescription: 'Implement an automated raw material tracking system.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Daily',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Tracking errors', 'Resource wastage'],
    auditTestingProcedures: ['Review consumption reports', 'Test system accuracy']
  },
  {
    industry: 'Manufacturing',
    department: 'Inventory',
    riskId: 'INV-020',
    riskDescription: 'Inventory mismanagement due to poor software integration - Issue 20',
    riskCause: ['Disparate systems', 'Lack of real-time data synchronization'],
    consequence: 'Inaccurate inventory records impacting overall operations.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-INV-020',
    processControlDescription: 'Integrate inventory software for real-time updates.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational/Financial',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Data sync issues', 'System errors'],
    auditTestingProcedures: ['Review integration logs', 'Test system performance']
  }
];

// Production Department Risks (20 records)
const manufacturingProductionRiskData = [
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-001',
    riskDescription: 'Production stoppage due to unexpected machine failure - Issue 1',
    riskCause: ['Aging machinery', 'Lack of preventive maintenance'],
    consequence: 'Missed production targets and delayed deliveries.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-001',
    processControlDescription: 'Schedule regular preventive maintenance and machine inspections.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Unexpected breakdowns', 'Maintenance delays'],
    auditTestingProcedures: ['Review maintenance records', 'Conduct machine inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-002',
    riskDescription: 'Delays caused by raw material shortages - Issue 2',
    riskCause: ['Supply chain disruptions', 'Poor forecasting'],
    consequence: 'Inability to meet production schedules.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-002',
    processControlDescription: 'Maintain inventory buffers and strengthen supplier relationships.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Material shortages', 'Delayed orders'],
    auditTestingProcedures: ['Review supplier performance', 'Examine inventory buffers']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-003',
    riskDescription: 'Inconsistent production output due to equipment calibration issues - Issue 3',
    riskCause: ['Lack of calibration', 'Equipment wear'],
    consequence: 'Variability in product quality and output rates.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-003',
    processControlDescription: 'Schedule routine calibration and equipment checks.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Calibration drifts', 'Quality variances'],
    auditTestingProcedures: ['Review calibration logs', 'Test equipment performance']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-004',
    riskDescription: 'Production inefficiencies due to outdated machinery - Issue 4',
    riskCause: ['Old equipment', 'Insufficient upgrades'],
    consequence: 'Lower production efficiency and higher operational costs.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-004',
    processControlDescription: 'Invest in technology upgrades and regular machinery overhauls.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Quarterly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Reduced output', 'Increased maintenance costs'],
    auditTestingProcedures: ['Review upgrade plans', 'Test machinery performance']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-005',
    riskDescription: 'Excessive downtime due to frequent machine repairs - Issue 5',
    riskCause: ['High wear rates', 'Lack of spare parts'],
    consequence: 'Extended production downtime and reduced output.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-005',
    processControlDescription: 'Maintain an inventory of spare parts and schedule timely repairs.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Frequent breakdowns', 'Repair delays'],
    auditTestingProcedures: ['Review repair logs', 'Inspect spare parts inventory']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-006',
    riskDescription: 'Quality issues causing rework and delays - Issue 6',
    riskCause: ['Substandard materials', 'Process variability'],
    consequence: 'Increased production costs and delayed shipments.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-006',
    processControlDescription: 'Implement quality checkpoints throughout the production process.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['High rework rates', 'Quality defects'],
    auditTestingProcedures: ['Review quality reports', 'Monitor defect rates']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-007',
    riskDescription: 'Bottlenecks in production due to inefficient scheduling - Issue 7',
    riskCause: ['Poor scheduling', 'Resource misallocation'],
    consequence: 'Delayed order fulfillment and increased lead times.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-007',
    processControlDescription: 'Optimize production scheduling and resource allocation.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Scheduling conflicts', 'Underutilized capacity'],
    auditTestingProcedures: ['Review production schedules', 'Analyze throughput data']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-008',
    riskDescription: 'Production slowdown due to inadequate maintenance - Issue 8',
    riskCause: ['Neglected maintenance', 'Poor monitoring systems'],
    consequence: 'Reduced machine efficiency and unexpected breakdowns.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-008',
    processControlDescription: 'Implement a proactive maintenance program with regular inspections.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Maintenance Manager',
    expectedDeviations: ['Increased wear', 'Delayed repairs'],
    auditTestingProcedures: ['Review maintenance schedules', 'Inspect equipment conditions']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-009',
    riskDescription: 'Operator errors due to fatigue impacting production quality - Issue 9',
    riskCause: ['Extended shifts', 'Insufficient breaks'],
    consequence: 'Erratic production output and potential safety hazards.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-009',
    processControlDescription: 'Implement shift rotations and enforce adequate break periods.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Increased errors', 'Safety incidents'],
    auditTestingProcedures: ['Review shift schedules', 'Monitor incident reports']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-010',
    riskDescription: 'High energy consumption causing production cost overruns - Issue 10',
    riskCause: ['Inefficient machinery', 'Poor energy management'],
    consequence: 'Increased operational costs affecting profitability.',
    riskCategory: 'Financial',
    processControlId: 'CTRL-PROD-010',
    processControlDescription: 'Upgrade to energy-efficient equipment and monitor energy usage.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Financial',
    frequency: 'Monthly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Excessive energy use', 'Inefficient operations'],
    auditTestingProcedures: ['Review energy bills', 'Test equipment efficiency']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-011',
    riskDescription: 'Delayed production start-up due to improper machine setup - Issue 11',
    riskCause: ['Improper setup procedures', 'Insufficient training'],
    consequence: 'Delayed production cycles and missed deadlines.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-011',
    processControlDescription: 'Standardize machine setup procedures and provide regular training.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Setup delays', 'Configuration errors'],
    auditTestingProcedures: ['Review setup logs', 'Interview operators']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-012',
    riskDescription: 'Production slowdown due to poor quality raw materials - Issue 12',
    riskCause: ['Substandard supplies', 'Inadequate supplier controls'],
    consequence: 'Increased waste and production delays.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-012',
    processControlDescription: 'Conduct rigorous supplier audits and raw material testing.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Material quality issues', 'Delayed production'],
    auditTestingProcedures: ['Review supplier performance', 'Test material quality']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-013',
    riskDescription: 'Production disruptions due to power outages - Issue 13',
    riskCause: ['Unstable power supply', 'Lack of backup systems'],
    consequence: 'Interrupted production and missed orders.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-013',
    processControlDescription: 'Install backup power solutions and monitor supply stability.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Facilities Manager',
    expectedDeviations: ['Power interruptions', 'Equipment shutdowns'],
    auditTestingProcedures: ['Review power logs', 'Test backup generators']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-014',
    riskDescription: 'Inconsistent production output due to lack of SOPs - Issue 14',
    riskCause: ['No standardized processes', 'Operator discretion'],
    consequence: 'Variable product quality and throughput.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-014',
    processControlDescription: 'Develop and enforce standard operating procedures (SOPs).',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Output variability', 'Quality fluctuations'],
    auditTestingProcedures: ['Review SOP adherence', 'Conduct production audits']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-015',
    riskDescription: 'Bottlenecks in material handling delaying production - Issue 15',
    riskCause: ['Inefficient handling systems', 'Poor layout design'],
    consequence: 'Reduced throughput and delayed orders.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-015',
    processControlDescription: 'Automate material handling and optimize plant layout.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Handling delays', 'Logistical bottlenecks'],
    auditTestingProcedures: ['Review material flow', 'Test automation systems']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-016',
    riskDescription: 'Excessive overtime causing operator fatigue and errors - Issue 16',
    riskCause: ['High production targets', 'Insufficient staffing'],
    consequence: 'Increased errors and potential safety incidents.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-016',
    processControlDescription: 'Optimize shift scheduling and limit overtime hours.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'HR Manager',
    expectedDeviations: ['Operator fatigue', 'Increased mistakes'],
    auditTestingProcedures: ['Review overtime records', 'Monitor error rates']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-017',
    riskDescription: 'Inability to meet high-volume orders due to limited machine capacity - Issue 17',
    riskCause: ['Outdated equipment', 'Poor capacity planning'],
    consequence: 'Failure to fulfill large orders on time.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-017',
    processControlDescription: 'Invest in capacity expansion and optimize production schedules.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Capacity constraints', 'Order delays'],
    auditTestingProcedures: ['Review capacity reports', 'Assess equipment utilization']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-018',
    riskDescription: 'Shift handover errors causing production inconsistencies - Issue 18',
    riskCause: ['Inefficient communication', 'Lack of structured handover'],
    consequence: 'Production errors and inconsistent quality.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-018',
    processControlDescription: 'Implement structured shift handover protocols with standardized reporting.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Communication gaps', 'Handover errors'],
    auditTestingProcedures: ['Review handover documents', 'Interview shift supervisors']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-019',
    riskDescription: 'Delays in machine setup affecting production start-up - Issue 19',
    riskCause: ['Improper setup procedures', 'Insufficient training'],
    consequence: 'Delayed production cycles and missed deadlines.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-019',
    processControlDescription: 'Standardize machine setup procedures and train operators thoroughly.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['Setup delays', 'Configuration errors'],
    auditTestingProcedures: ['Review setup logs', 'Conduct setup observations']
  },
  {
    industry: 'Manufacturing',
    department: 'Production',
    riskId: 'PROD-020',
    riskDescription: 'Machine downtime due to software glitches - Issue 20',
    riskCause: ['Software errors', 'Inadequate IT support'],
    consequence: 'Unplanned production stoppages affecting output.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-PROD-020',
    processControlDescription: 'Implement regular software maintenance and rapid IT support protocols.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Software failures', 'Delayed IT response'],
    auditTestingProcedures: ['Review IT support logs', 'Test software updates']
  }
];

// Quality Department Risks (20 records)
const manufacturingQualityRiskData = [
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-001',
    riskDescription: 'Defective products due to inadequate quality inspections - Issue 1',
    riskCause: ['Insufficient inspection processes', 'Lack of training'],
    consequence: 'Increased customer complaints and potential recalls.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-001',
    processControlDescription: 'Implement rigorous quality inspection procedures at all production stages.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Missed defects', 'Inconsistent inspections'],
    auditTestingProcedures: ['Review inspection records', 'Conduct random product tests']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-002',
    riskDescription: 'Product recalls due to non-compliance with quality standards - Issue 2',
    riskCause: ['Poor quality control', 'Inadequate compliance checks'],
    consequence: 'Regulatory fines and loss of market trust.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-002',
    processControlDescription: 'Regularly audit quality standards and perform compliance reviews.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Non-compliance incidents', 'Delayed corrective actions'],
    auditTestingProcedures: ['Review compliance reports', 'Inspect product samples']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-003',
    riskDescription: 'Inconsistent product quality due to calibration errors - Issue 3',
    riskCause: ['Lack of equipment calibration', 'Infrequent checks'],
    consequence: 'Variability in product quality leading to rework and scrap.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-003',
    processControlDescription: 'Schedule routine calibration and validation of all testing equipment.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Calibration drifts', 'Testing inaccuracies'],
    auditTestingProcedures: ['Review calibration logs', 'Test measurement tools']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-004',
    riskDescription: 'Delayed defect detection leading to increased rework - Issue 4',
    riskCause: ['Inefficient detection systems', 'Slow reporting mechanisms'],
    consequence: 'Higher production costs and delayed shipments.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-004',
    processControlDescription: 'Implement real-time defect detection and faster reporting.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive & Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Late defect identification', 'Increased rework'],
    auditTestingProcedures: ['Monitor defect logs', 'Conduct sample inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-005',
    riskDescription: 'Failure to meet regulatory standards due to inadequate testing - Issue 5',
    riskCause: ['Insufficient testing protocols', 'Lack of regulatory updates'],
    consequence: 'Regulatory penalties and potential market withdrawal.',
    riskCategory: 'Compliance',
    processControlId: 'CTRL-QLT-005',
    processControlDescription: 'Enhance testing protocols and ensure regular compliance training.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Compliance',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Non-compliance incidents', 'Delayed corrective actions'],
    auditTestingProcedures: ['Review test reports', 'Audit compliance processes']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-006',
    riskDescription: 'Customer dissatisfaction due to inconsistent product finish - Issue 6',
    riskCause: ['Variability in finishing processes', 'Lack of standardization'],
    consequence: 'Negative impact on brand reputation and repeat business loss.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-006',
    processControlDescription: 'Standardize finishing processes and enforce quality checks.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Finish variations', 'Customer complaints'],
    auditTestingProcedures: ['Review finish quality logs', 'Conduct product inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-007',
    riskDescription: 'Defective components due to supplier quality issues - Issue 7',
    riskCause: ['Substandard raw materials', 'Lack of supplier audits'],
    consequence: 'Production delays and increased scrap rates.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-007',
    processControlDescription: 'Conduct rigorous supplier quality audits and implement incoming material inspections.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Procurement Manager',
    expectedDeviations: ['Supplier non-compliance', 'Quality defects'],
    auditTestingProcedures: ['Review supplier audit reports', 'Test incoming materials']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-008',
    riskDescription: 'Recurring defects due to ineffective corrective actions - Issue 8',
    riskCause: ['Inadequate root cause analysis', 'Poor corrective planning'],
    consequence: 'Persistent quality issues and increased warranty claims.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-008',
    processControlDescription: 'Implement robust corrective action procedures and monitor their effectiveness.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Recurring defects', 'Ineffective actions'],
    auditTestingProcedures: ['Review corrective action logs', 'Conduct follow-up audits']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-009',
    riskDescription: 'Inaccurate test results due to uncalibrated equipment - Issue 9',
    riskCause: ['Neglected calibration schedules', 'Operator errors'],
    consequence: 'Erroneous quality assessments impacting production decisions.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-009',
    processControlDescription: 'Enforce regular calibration of all testing equipment.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Calibration drifts', 'Inaccurate measurements'],
    auditTestingProcedures: ['Review calibration certificates', 'Test equipment accuracy']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-010',
    riskDescription: 'Delayed quality reporting due to manual data collection - Issue 10',
    riskCause: ['Fragmented reporting systems', 'Manual entry errors'],
    consequence: 'Slow response to quality issues causing production delays.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-010',
    processControlDescription: 'Integrate quality data into a centralized automated reporting system.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'IT Manager',
    expectedDeviations: ['Data lags', 'Incomplete reports'],
    auditTestingProcedures: ['Review report logs', 'Test data integration']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-011',
    riskDescription: 'Excessive rework due to undetected defects - Issue 11',
    riskCause: ['Insufficient inspections', 'Lack of quality checkpoints'],
    consequence: 'Increased production costs and wasted resources.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-011',
    processControlDescription: 'Enhance defect detection measures and enforce quality checks at critical stages.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Undetected defects', 'High rework rates'],
    auditTestingProcedures: ['Review rework records', 'Conduct random inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-012',
    riskDescription: 'Process deviations undetected due to irregular audits - Issue 12',
    riskCause: ['Infrequent audits', 'Limited oversight'],
    consequence: 'Persistent quality deviations impacting product consistency.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-012',
    processControlDescription: 'Conduct regular process audits and implement corrective measures promptly.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Audit gaps', 'Ongoing deviations'],
    auditTestingProcedures: ['Review audit reports', 'Perform surprise inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-013',
    riskDescription: 'Loss of international certifications due to non-compliance - Issue 13',
    riskCause: ['Outdated quality protocols', 'Lack of continuous improvement'],
    consequence: 'Loss of certifications and diminished market credibility.',
    riskCategory: 'Compliance',
    processControlId: 'CTRL-QLT-013',
    processControlDescription: 'Regularly update quality protocols and conduct external audits.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Compliance',
    frequency: 'Quarterly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Non-compliance findings', 'Certification lapses'],
    auditTestingProcedures: ['Review external audit reports', 'Test updated processes']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-014',
    riskDescription: 'High scrap rates due to process inefficiencies - Issue 14',
    riskCause: ['Inefficient production processes', 'Poor quality controls'],
    consequence: 'Increased waste and reduced profitability.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-014',
    processControlDescription: 'Implement lean manufacturing principles and quality improvement initiatives.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Production Manager',
    expectedDeviations: ['High scrap rates', 'Process inefficiencies'],
    auditTestingProcedures: ['Review scrap reports', 'Conduct process audits']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-015',
    riskDescription: 'Variability in product dimensions due to measurement errors - Issue 15',
    riskCause: ['Inaccurate measurement tools', 'Operator error'],
    consequence: 'Non-conforming products and increased waste.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-015',
    processControlDescription: 'Calibrate measurement tools regularly and train operators on proper usage.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Measurement discrepancies', 'Operator mistakes'],
    auditTestingProcedures: ['Review calibration records', 'Test measurement accuracy']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-016',
    riskDescription: 'Delayed detection of process deviations causing quality issues - Issue 16',
    riskCause: ['Inefficient monitoring', 'Slow reporting mechanisms'],
    consequence: 'Quality issues persist and affect production output.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-016',
    processControlDescription: 'Implement continuous monitoring systems for early detection of deviations.',
    processControlDesign: 'automated',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Daily',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Late detection', 'Delayed reporting'],
    auditTestingProcedures: ['Review monitoring data', 'Conduct real-time tests']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-017',
    riskDescription: 'Inconsistent product finish due to variable processes - Issue 17',
    riskCause: ['Lack of standardized finishing procedures', 'Operator discretion'],
    consequence: 'Variability in product appearance and reduced customer satisfaction.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-017',
    processControlDescription: 'Standardize finishing processes and implement regular quality checks.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Finish variations', 'Customer complaints'],
    auditTestingProcedures: ['Review finish quality logs', 'Conduct product inspections']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-018',
    riskDescription: 'Damaged packaging causing product damage during transit - Issue 18',
    riskCause: ['Poor packaging materials', 'Inefficient packing procedures'],
    consequence: 'Product damage during shipping and increased returns.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-018',
    processControlDescription: 'Upgrade packaging standards and perform regular quality checks on packaging.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Preventive',
    processControlCategory: 'Operational',
    frequency: 'Monthly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Packaging defects', 'Transit damage'],
    auditTestingProcedures: ['Review packaging quality', 'Test packaging durability']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-019',
    riskDescription: 'Extended quality issue resolution causing recurring defects - Issue 19',
    riskCause: ['Inefficient communication', 'Slow management response'],
    consequence: 'Prolonged periods of defects and increased waste.',
    riskCategory: 'Operational',
    processControlId: 'CTRL-QLT-019',
    processControlDescription: 'Enhance communication channels and expedite corrective actions.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Operational',
    frequency: 'Weekly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Delayed responses', 'Recurring issues'],
    auditTestingProcedures: ['Review response times', 'Monitor corrective action logs']
  },
  {
    industry: 'Manufacturing',
    department: 'Quality',
    riskId: 'QLT-020',
    riskDescription: 'Failure to update quality protocols with new standards - Issue 20',
    riskCause: ['Outdated procedures', 'Lack of continuous improvement'],
    consequence: 'Non-compliance with industry standards and increased defect rates.',
    riskCategory: 'Compliance',
    processControlId: 'CTRL-QLT-020',
    processControlDescription: 'Regularly update quality protocols and provide staff training on new standards.',
    processControlDesign: 'manual',
    typeOfProcessControl: 'Detective',
    processControlCategory: 'Compliance',
    frequency: 'Quarterly',
    processControlOwner: 'Quality Manager',
    expectedDeviations: ['Non-compliance', 'Outdated processes'],
    auditTestingProcedures: ['Review protocol updates', 'Conduct compliance audits']
  }
];

const manufacturingRiskData = [
  ...manufacturingInventoryRiskData,
  ...manufacturingProductionRiskData,
  ...manufacturingQualityRiskData
];

export default manufacturingRiskData;
